"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _crmApi = require("@ys/crm-api");
var _tree = require("@ys/utils/lib/tree");
var _lodash = require("lodash");
var _default = exports.default = {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      departmentTree: [],
      currentDepartmentId: undefined,
      checkedDepartmentIds: [],
      userList: [],
      checkedUserIds: [],
      searchKeyword: undefined
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    departmentBreadcrumb() {
      return (0, _tree.findPath)(this.departmentTree, department => department.id === this.currentDepartmentId);
    },
    renderDepartmentTree() {
      if (!this.currentDepartmentId) {
        return this.departmentTree;
      }
      return (0, _tree.findNode)(this.departmentTree, department => department.id === this.currentDepartmentId)?.children ?? [];
    },
    renderUserList() {
      if (this.searchKeyword) {
        return (0, _lodash.uniqBy)(this.userList.filter(user => user.userName.includes(this.searchKeyword)), 'userId');
      }
      return this.userList.filter(user => user.deptId === this.currentDepartmentId);
    },
    renderUsers() {
      return (0, _lodash.uniqBy)(this.userList.filter(user => this.modelValue.includes(user.userId)), 'userId');
    }
  },
  watch: {
    modelValue(value = []) {
      this.checkedUserIds = [...value];
      this.resetCheckedDepartmentIds();
    }
  },
  mounted() {
    this.getDepartmentTree();
    this.getUserList();
  },
  methods: {
    open() {
      this.searchKeyword = undefined;
      this.visible = true;
    },
    async getDepartmentTree() {
      const res = await _crmApi.YcCrmDeptService.getDepartmentTree();
      this.departmentTree = res.data.data;
      this.currentDepartmentId = this.departmentTree?.[0]?.id;
    },
    changeCurrentDepartment(department) {
      this.currentDepartmentId = department.id;
    },
    async getUserList() {
      const res = await _crmApi.YcUserService.getUserAllDeptBlocked();
      this.userList = res.data.data ?? [];
    },
    resetCheckedDepartmentIds() {
      this.checkedDepartmentIds = [];
      this.departmentTree.forEach(department => {
        this.resetDepartmentChecked(department);
      });
    },
    resetDepartmentChecked(department) {
      const departmentUser = this.userList.filter(user => user.deptId === department.id);
      const isAllUserChecked = departmentUser.every(user => this.checkedUserIds.includes(user.userId));
      let isAllChildChecked = true;
      department.children.forEach(child => {
        const isChildChecked = this.resetDepartmentChecked(child);
        if (!isChildChecked) {
          isAllChildChecked = false;
        }
      });
      if (isAllUserChecked && isAllChildChecked && !this.isEmptyDepartment(department)) {
        this.checkedDepartmentIds.push(department.id);
      }
      return isAllUserChecked && isAllChildChecked;
    },
    isEmptyDepartment(department) {
      const hasUser = this.userList.some(user => user.deptId === department.id);
      if (hasUser) {
        return false;
      }
      if (department.children?.length) {
        return department.children.every(this.isEmptyDepartment);
      }
      return true;
    },
    handleDepartmentChange(department) {
      const foundCheckDepartmentIndex = this.checkedDepartmentIds.findIndex(id => id === department.id);
      const check = foundCheckDepartmentIndex === -1;
      this.setDepartmentCheck(department, check);
      department.children?.forEach(child => this.setDepartmentCheck(child, check));
      this.resetCheckedDepartmentIds();
    },
    setDepartmentCheck(department, checked) {
      const departmentUserIds = this.userList.filter(user => user.deptId === department.id).map(user => user.userId);
      if (checked) {
        departmentUserIds.forEach(userId => {
          if (!this.checkedUserIds.includes(userId)) {
            this.checkedUserIds.push(userId);
          }
        });
        this.checkedDepartmentIds.push(department.id);
      } else {
        departmentUserIds.forEach(userId => {
          const index = this.checkedUserIds.findIndex(id => id === userId);
          if (index !== -1) {
            this.checkedUserIds.splice(index, 1);
          }
        });
        const foundCheckDepartmentIndex = this.checkedDepartmentIds.findIndex(id => id === department.id);
        this.checkedDepartmentIds.splice(foundCheckDepartmentIndex, 1);
      }
    },
    handleUserCheckboxChange(e) {
      const {
        checked,
        value
      } = e.target;
      if (!checked) {
        const index = this.checkedUserIds.findIndex(item => item === value);
        this.checkedUserIds.splice(index, 1);
      } else {
        this.checkedUserIds.push(value);
      }
      this.resetCheckedDepartmentIds();
    },
    confirm() {
      this.modelValue = this.checkedUserIds;
      this.visible = false;
    },
    remove(userId) {
      const index = this.modelValue.indexOf(userId);
      this.modelValue.splice(index, 1);
    }
  }
};